<template>
  <form id="instanceSliceProfileForm">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.instanceSliceProfileName')}} :</div>
        <ejs-textbox name="nameCheck" v-model="name"></ejs-textbox>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.sst')}} :</div>
        <ejs-dropdownlist
          :dataSource="sstList"
          v-model="sst"
          name="sstCheck"
          :fields="fieldsOfSST"
          @change="changeForStatus"
        ></ejs-dropdownlist>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.sd')}} :</div>
        <ejs-textbox name="sdCheck" v-model="sd"></ejs-textbox>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.envChoice')}} :</div>
          <ejs-dropdownlist
            ref="envSelect"
            id="environmentParent"
            :fields="fieldsEnv"
            :dataSource="envItems"
            popupHeight="200"
            v-model="environmentParent"
            :change="onMethodChangeParent"
            name="environmentCheck"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
     <!-- <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.runMode')}} :</div>
          <ejs-dropdownlist
            ref="runModeSelect"
            id="runModeId"
            :fields="fieldsRunMode"
            :dataSource="runModeItems"
            popupHeight="200"
            v-model="runMode"
            :change="onMethodChangeRunMode"
            name="runModeCheck"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div> -->
  </form>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";

export default {
  name: "InstanceSliceProfileDetail",
  components: {},
  data() {
    return {
      environmentParent: 0,
      envItems: [],
      sst: "",
      sd: "",
      name: "",
      envIpParent: "",
      runMode: "",
      fieldsOfSST: {
        text: "text",
        value: "value"
      },
      fieldsRunMode: {
        text: "text",
        value: "value"
      },
      runModeItems: [
        { text: `${this.$t("NSMF.oamOne")}`, value: "1" },
        { text: `${this.$t("NSMF.oamMore")}`, value: "2" }
      ],
      fieldsEnv: { text: "k8sName", value: "id" },
      sstList: [
        { text: "eMBB", value: "1" },
        { text: "URLLC", value: "2" },
        { text: "MIoT", value: "3" },
        { text: "V2X", value: "4" }
      ],
      locale: localStorage.getItem("locale"),

      formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          environmentCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`]
          },
          nameCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: [/^(^\S)/, `${this.$t("Topo.noEmptyStart")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          },
          sstCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`]
          },
          sdCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 16777215], `${this.$t('NSMF.inputRangeIllegal')}`], 
          }
        }
      }
    };
  },
  methods: {
    changeForStatus(msg) {
      this.sst = msg.value;
    },
    clear() {
      this.sd = "";
      this.sst = "";
      this.name = "";
    },
    onMethodChangeParent(e) {
      for (var i = 0; i < this.envItems.length; i++) {
        if (this.envItems[i].id == this.environmentParent) {
          this.envIpParent = this.envItems[i].k8sEnvIp;
        }
      }
      EventBus.$emit("environmentParam", {
        environmentParent: this.environmentParent,
        envIp: this.envIpParent
      });
      this.$parent.$refs.deployCase36[0].onMethodChange();
      this.$parent.$refs.deployCase37[0].onMethodChange();
      this.$parent.$refs.deployCase38[0].onMethodChange();
      this.$parent.$refs.deployCase39[0].onMethodChange();
      this.$parent.$refs.deployCase41[0].onMethodChange();
      this.$parent.$refs.deployCase42[0].onMethodChange();
    },
    onMethodChangeRunMode(e){
      this.$emit("runModeParam", e.value)
    },
    init(checkedData) {
      this.sd = checkedData.sNSSAIList.split(":")[1];
      this.sst = checkedData.sNSSAIList.split(":")[0];
      this.getEnvItems();
      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    getEnvItems() {
      this.$axios
        .get("/lte/ems/env/getEnvironmentWithIngressIp")
        .then(response => {
          this.envItems = response.data.resultVal;
        });
    },
    checkReapetSliceProfileSST(sNSSAIList,name, callback) {
      this.$axios
        .post(
          `/lte/ems/networkSlice/checkNetworkSliceSubnet`
          ,{name: name,snssaiList:sNSSAIList}
        )
        .then(response => {
          if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
            if (callback) {
              callback(true);
            }
          } else {
            EventBus.$emit("toast", {
              type: "warning",
              content: response.data.errorString
            });
            if (callback) {
              callback(false);
            }
          }
        });
    },
    getInstanceBase(callback) {
      if (!this.validate()) {
          if (callback) {
            callback(false);
          }      
          }
      const sNSSAIList = this.sst + ":" + this.sd;
      this.checkReapetSliceProfileSST(sNSSAIList,this.name, res => {
        if (!res) {
          if (callback) {
            callback(false);
          }
        } else {
          if (callback) {
            callback({
              sNSSAIList: sNSSAIList,
              name: this.name,
              environment: this.environmentParent,
              envIpParent: this.envIpParent
            });
          }
        }
      });
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#instanceSliceProfileForm",
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
